import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from '@/plugins/vuetify'
import moment from 'moment-timezone'
import './assets/global-styles.css'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

Vue.config.productionTip = false
Vue.prototype.$moment = moment

Sentry.init({
  Vue,
  dsn: 'https://23281a5f4a5e41e3bbc4fdc9d23b9e8d@o1357850.ingest.sentry.io/4504600975114240',
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: [
        'gps.usa-transfers.com',
        'callfree.usa-transfers.com',
        'us-central1-usatransfersclients.cloudfunctions.net',
        /^\//
      ]
    })
  ],
  tracesSampleRate: 0.2
})

new Vue({
  store,
  router,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
